<template>
  <div class="app-list-wrap">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">应用</span>
        <div class="search">
          <el-input
            v-model="searchAppText"
            size="small"
            placeholder="搜索应用名称"
            clearable
            prefix-icon="el-icon-search"
          ></el-input>
        </div>
        <tabs
          :tab-list="appTabs"
          :default-active="activeType"
          @click="changeTab"
          class="tabs"
        ></tabs>
      </div>
      <div v-loading="loading">
        <ul class="app-list" v-if="loading || (filterApps && filterApps.length > 0)">
          <draggable
            group="apps"
            :disabled="activeType !== 'star'"
            v-model="favoriteAppIds"
            :animation="100"
            @update="changeFavoriteList"
            style="display: flex; flex-wrap: wrap;"
          >
            <li
              v-for="app in filterApps"
              :key="app.id"
              @click="clickApp(app)"
              @mouseenter="changeMouseIn(app.id, true)"
              @mouseleave="changeMouseIn(app.id, false)"
            >
              <div style="position: absolute">
                <svg-icon
                  v-if="mouseIn[app.id]"
                  class="favorite"
                  :icon-class="app.favorite ? 'star_add-favorite' : 'star_not-add-favorite'"
                  @click.native.stop="setAppFavorite(app.id)"
                ></svg-icon>
              </div>
              <span class="app-icon" :style="{ background: app.color }">
                <svg-icon :icon-class="app.icon ? 'app_' + app.icon : 'app_icon-01'"></svg-icon>
              </span>
              <span class="app-name" v-tip="2">{{ app.name }}</span>
            </li>
            <li class="add" v-if="appPermission && activeType === 'all'">
              <dropdown-menu
                :menu-list="operation"
                @click="handleCommand($event)"
                placement="bottom-start"
                width="170"
              >
                <div class="add-app">
                  <i class="el-icon-plus"></i>
                </div>
              </dropdown-menu>
              <span class="app-name" v-tip="2">新建应用</span>
            </li>
          </draggable>
        </ul>
        <div v-else class="filter-empty">
          <svg-icon icon-class="noApp"></svg-icon>
          <div class="no-available">
            暂无应用
            <template v-if="activeType === 'all' && apps && apps.length === 0 && appPermission">
              <span>,</span>
              <span class="create" @click="goManageApp">
                立即添加+
              </span>
            </template>
          </div>
        </div>
      </div>
    </el-card>
    <base-dialog :visible.sync="appVisible" :show-close="true">
      <template v-slot:header>
        <div>新建应用</div>
      </template>
      <el-form class="form" :model="curApp" label-width="88px" label-position="left">
        <el-form-item label="应用名称">
          <el-input v-model.trim="curApp.name"></el-input>
        </el-form-item>
        <el-form-item label="设计图标" class="design-icon">
          <span
            class="icon-info"
            :style="curApp.color ? 'background:' + curApp.color : 'background:' + appColors[0]"
          >
            <svg-icon
              style="color: #fff"
              :icon-class="curApp.icon ? 'app_' + curApp.icon : 'app_' + appIcons[0]"
            ></svg-icon>
          </span>
          <design-icon-popper
            style="margin: 4px 8px"
            :colors="appColors"
            :icons="appIcons"
            :cur-data="curApp"
            from="app"
            @changeData="changeAppInfo"
          ></design-icon-popper>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button @click="appVisible = false">取消</base-button>
        <base-button type="primary" @click="addApp">确定</base-button>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { getFavoriteList, getAppList, setFavoriteList } from "@/api/userCenter/app"
import { getAppGroupList } from "@/api/user"
import { checkCompanyPermission } from "@/utils/checkPermission"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import Tabs from "@/components/UIComponents/Tab"
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/BaseComponents/Dialog"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"
import { operation } from "@/views/System/Home/static"
import { appIcons, appColors } from "@/views/Company/Manage/App/static"
import * as appApi from "@/api/userCenter/app"

export default {
  name: "app-list",
  components: { draggable, DropdownMenu, Tabs, BaseButton, BaseDialog, DesignIconPopper },
  props: { userInfo: Object },
  filters: {
    getPercentage(val) {
      return Math.floor(val * 100)
    }
  },
  data() {
    return {
      operation,
      appIcons,
      appColors,
      searchAppText: "",
      appList: [],
      favoriteAppIds: [],
      activeType: "all",
      groupAppList: [],
      mouseParam: {
        appId: "",
        param: ""
      },
      appPermission: false,
      loading: true,
      appVisible: false,
      curApp: {
        name: "",
        color: "",
        icon: ""
      }
    }
  },
  computed: {
    allApps() {
      return this.appList.map(app => {
        app.favorite = this.favoriteAppIds.includes(app.id)
        return app
      })
    },
    appMap() {
      let result = {}
      this.allApps.forEach(item => {
        result[item.id] = item
      })
      return result
    },
    favoriteApps() {
      let result = []
      this.favoriteAppIds.forEach(appId => {
        if (this._.keys(this.appMap).includes(appId)) {
          result.push(this.appMap[appId])
        }
      })
      return result
    },
    groupApps() {
      let result = {}
      this.groupAppList.forEach(t => {
        let list = []
        t.appIdList.forEach(appId => {
          if (this._.keys(this.appMap).includes(appId)) {
            let app = this.appMap[appId]
            app.favorite = this.favoriteAppIds.includes(appId)
            list.push(app)
          }
        })
        result[t.id] = list
      })
      return result
    },
    groupAppTabs() {
      let result = []
      this.groupAppList.forEach(t => {
        if (this.groupApps[t.id].length > 0) {
          result.push({ label: t.name, value: t.id })
        }
      })
      return result
    },
    appTabs() {
      return (this.favoriteApps.length > 0 ? [{ label: "星标应用", value: "star" }] : [])
        .concat([{ label: "全部应用", value: "all" }])
        .concat(this.groupAppTabs)
    },
    apps() {
      switch (this.activeType) {
        case "all":
          return this.allApps
        case "star":
          return this.favoriteApps || []
        default:
          return this.groupApps[this.activeType] || []
      }
    },
    filterApps() {
      return this.apps.filter(app => app.name.includes(this.searchAppText))
    },
    mouseIn() {
      let result = {}
      this.filterApps.forEach(app => {
        if (this.mouseParam.appId === app.id) {
          result[app.id] = this.mouseParam.param
        } else {
          result[app.id] = false
        }
      })
      return result
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.appPermission = checkCompanyPermission({
        companyId: this.userInfo.companyId,
        pri: "应用列表"
      })
      let promises = [getFavoriteList("app"), getAppList("MEMBER"), getAppGroupList()]
      Promise.all(promises)
        .then(([res1, res2, res3]) => {
          this.favoriteAppIds = res1 || []
          this.appList = res2
          this.groupAppList = res3
          this.activeType = this.appTabs[0]?.value
        })
        .finally(() => {
          this.loading = false
        })
    },
    setAppFavorite(appId) {
      if (this.favoriteAppIds.includes(appId)) {
        let index = this.favoriteAppIds.indexOf(appId)
        this.favoriteAppIds.splice(index, 1)
        if (this.favoriteApps.length === 0) {
          this.activeType = "all"
        }
      } else {
        this.favoriteAppIds.push(appId)
      }
      setFavoriteList(this.favoriteAppIds, "app")
    },
    changeFavoriteList() {
      setFavoriteList(this.favoriteAppIds, "app")
    },
    changeMouseIn(appId, param) {
      this.mouseParam.appId = appId
      this.mouseParam.param = param
    },
    goManageApp() {
      const { href } = this.$router.resolve({
        name: "company-manage-app",
        query: {
          dialogName: "add"
        }
      })
      window.open(href, "_blank")
    },
    changeTab(key) {
      this.activeType = key
    },
    clickApp(app) {
      this.$router.push({
        name: "worksheet",
        params: {
          appId: app.id
        }
      })
    },
    handleCommand(command) {
      switch (command) {
        case "addEmptyApp":
          this.appVisible = true
          break
        case "fromTemplateCenter":
          this.goToTemplateCenter()
          break
      }
    },
    goToTemplateCenter() {
      const { href } = this.$router.resolve({
        name: "app-template-center",
        query: { from: "home" }
      })
      window.open(href, "_blank")
    },
    changeAppInfo(key, val) {
      this.$set(this.curApp, key, val)
    },
    addApp() {
      let reg = /[\\\\/?"!#]/
      if (reg.test(this.curApp.name)) {
        return this.$message.error('应用名称不能包含特殊字符 （\\ / ? " ! #）')
      }
      appApi.createApp(this.curApp).then(app => {
        this.appVisible = false
        this.$message.success("创建成功")
        this.$router.goto({ name: "admin-app-info", params: { appId: app.id } })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-list-wrap {
  min-height: 339px;
  .el-card {
    min-height: 338px;
    border-radius: 6px;
  }
  .clearfix {
    border-bottom: 1px solid #ebeef5;
  }
  .title {
    font-size: 20px;
    margin-left: 12px;
  }
  .search {
    float: right;
    display: flex;
  }
  .tabs {
    margin-top: 10px;
  }
  .app-list {
    margin: 0;
    list-style-type: none;
    display: flex;
    padding: 0;
    flex-wrap: wrap;
    font-size: 13px;
    color: #333;
    min-height: 200px;
    line-height: 1.5;
    li:not(.add):hover {
      border-radius: 6px;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    }
    .add {
      margin-top: 22px;
      cursor: unset;
    }
    li {
      margin: 6px 9px;
      width: 100px;
      height: 120px;
      display: inline-flex;
      align-items: center;
      flex-direction: column;
      padding: 12px 10px 0;
      text-align: center;
      cursor: pointer;
      list-style: none;
      .favorite {
        top: -6px;
        left: 30px;
        position: absolute;
        font-size: 16px;
      }
      .app-icon {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 54px;
        height: 54px;
        background: #1989fa;
        margin-top: 14px;
        color: #fff;
        font-size: 35px;
        border-radius: 14px;
      }
      .app-name {
        width: 100px;
        margin-top: 8px;
        font-size: 14px;
        color: #606266;
      }
      .add-app {
        @include flex-center;
        width: 54px;
        height: 54px;
        border-radius: 14px;
        background: #f5f7fa;
        color: #c0c4cc;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .filter-empty {
    text-align: center;
    min-height: 200px;
    .svg-icon,
    i {
      font-size: 160px;
      color: #fff;
    }
  }
  ::v-deep {
    .el-card__body {
      margin: 0 20px;
      padding: 20px 0;
    }
    .el-card__header {
      padding: 18px 20px 0 20px;
      border-bottom: none;
    }
    .el-icon-star-off:before {
      font-size: 15px;
    }
  }
  .no-available {
    color: #c0c4cc;
    font-size: 14px;
    .create {
      color: #1989fa;
    }
  }
}
.form {
  padding-top: 14px;
  .design-icon {
    .icon-info {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      font-size: 30px;
      border-radius: 6px;
    }
    ::v-deep {
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}
</style>
